import { TransferStatus } from "../../../../common/enums";
import styles from "./InventoryTransferStatusBadge.module.scss";

interface IStatusBadgeProps {
  status: TransferStatus;
  isDeleted?: boolean;
}

export const InventoryTransferStatusBadge = ({ status, isDeleted }: IStatusBadgeProps) => {
  if (isDeleted) {
    return <span className={`${styles.badge} ${styles.deleted}`}>Изтрита</span>;
  }

  if (status === TransferStatus.Completed) {
    return <span className={`${styles.badge} ${styles.completed}`}>Завършена</span>;
  }

  return <span className={`${styles.badge} ${styles.planned}`}>Планирана</span>;
};
